import FieldConfig from "../../../../proto/field-config"
import FieldDate from "../../../../generic/datetime/date/date"
import Task from "../../../../../model2/task/task"
import ItemModelV2 from "../../../../../model2/item2/item-model"
import FieldTaskSchedule_Popover from "./components/popover/popover"
import FieldTaskSchedule_TableCell from "./render/table/table-cell"
import TasksViewManager from "../../../../../gd-modules/tasks-view/core/manager"
import {ScheduleStatus} from "../../../../../gd/types/types"
import DatetimeUtils from "../../../../../gd/utils/datetime-utils"
import {SortDirection} from "../../../../../data-structures/sort"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"

export const SCHEDULE_SOMEDAY = 'schedule-someday'

export default class FieldTaskSchedule extends FieldDate {

    constructor(config:FieldConfig) {
        super(config)

        this.icon               = 'i5-date-schedule'
        this.label              = _.get(config, 'label', 'Schedule date')

        this.minDate            = moment()
        this.fieldParams.highlightIfPastdue = true
        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange

        this.components.PopoverMenu     = FieldTaskSchedule_Popover
        this.renderComponents.tableCell = FieldTaskSchedule_TableCell
    }

    // ACCESS
    canEdit(model:Task):boolean {
        return model.acl.canChangeScheduleDate
    }

    // Custom Methods
    listItemSortFunctions(sort: SortDirection):any {
        return {
            functions: [
                (listItem: ItemModelV2) => {
                    switch (listItem.task?.scheduleStatus) {
                        case ScheduleStatus.SOMEDAY:
                            return 2

                        case ScheduleStatus.SCHEDULED:
                            return 1

                        case ScheduleStatus.NOT_SCHEDULED:
                        default:
                            return 0
                    }
                },
                (listItem: ItemModelV2) => {
                    switch (listItem.task.scheduleStatus) {
                        case ScheduleStatus.SCHEDULED:
                            return DatetimeUtils.dateToMoment(listItem.task.scheduleDate!).format('x')

                        default:
                            return ''
                    }
                }
            ],
            directions: [sort, sort]
        }
    }

    // used to be
    tableCellOnValueChange = async (item: ItemModelV2, value:any, manager:TasksViewManager) => {

        if (value === SCHEDULE_SOMEDAY) {
            item.task.updateSchedule(null, ScheduleStatus.SOMEDAY)
        } else if (!value) {
            item.task.updateSchedule(null, ScheduleStatus.NOT_SCHEDULED)
        } else {
            item.task.updateSchedule(value, ScheduleStatus.SCHEDULED)
        }

        item.updateLastUpdateTime() // otherwise it wont re-render

        // Aggregated values...
        FieldProto_updateView(manager as TasksViewManager, this)

        // strange if it's about it WAITS without await ...
        item.task.save()

    }

}
